import type React from 'react';
import { useIsNonVisitorUser } from '../../account/useIsLoggedIn';

interface UserRoleRouterProps {
  user: React.ReactNode;
  anonymous: React.ReactNode;
}
const UserRoleRouter = ({ user, anonymous }: UserRoleRouterProps) => {
  const isNonVisitorUser = useIsNonVisitorUser();

  return isNonVisitorUser ? user : anonymous;
};

export default UserRoleRouter;
